if (!customElements.get('emergent-service-process')) {
  customElements.define(
    'emergent-service-process',
    class EmergentServiceProcess extends HTMLElement {
      connectedCallback() {
        this.mainProduct = this.closest('product-info[id^="MainProduct-"]') || document.querySelector(`product-info[id^="MainProduct-"][data-product-id="${this.dataset.productId}"]`);
        if (this.mainProduct?.dataset.productId !== this.dataset.productId) return;
        this.titleElement = this.querySelector('[data-service-title]');
        this.copy = this.querySelector('[data-service-copy]');
        this.procedures = new Map(
          [...this.querySelectorAll('template[data-service-variant]')].map((template) => [template.dataset.serviceVariant, template])
        );
        this.onVariantInputChange = this.onVariantInputChange.bind(this);
        this.mainProduct.addEventListener('change', this.onVariantInputChange);
        const input = this.mainProduct.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        if (input) this.showProcedure(input.value);
      }

      disconnectedCallback() {
        this.mainProduct?.removeEventListener('change', this.onVariantInputChange);
      }

      onVariantInputChange(event) {
        const input = event.target;
        if (!input.matches?.('form[data-type="add-to-cart-form"] input[name="id"]')) return;
        if (input.closest('product-info[id^="MainProduct-"]') !== this.mainProduct) return;
        this.showProcedure(input.value);
      }

      showProcedure(variantId) {
        const template = this.procedures.get(String(variantId));
        if (!this.titleElement || !this.copy) return;
        this.hidden = !template;
        this.titleElement.textContent = template?.dataset.serviceTitle || '';
        this.copy.replaceChildren(...(template ? [template.content.cloneNode(true)] : []));
      }
    }
  );
}
